import Helpers from '../modules/Helpers'

const body = document.querySelector('body')
const resultsFilterToggle = document.getElementsByClassName('results-mobile-nav__filter')
const resultsFilterClose = document.getElementsByClassName('results-aside__close')
const resultFilterApply = document.getElementsByClassName('results-aside__apply-filter')

// Results filter active classes
const resultsFilterClass = 'results-aside--active'
const noScrollClass = 'no-scroll'

// Show results page mobile 'Filter by'
// navigation when clicking open button.
new Helpers(resultsFilterToggle).eventListener((e) => {
    e.preventDefault()

    new Helpers(body).addClass(
        resultsFilterClass,
        noScrollClass,
    )
})

// Hide all active results page mobile filters
// when clicking close button.
new Helpers(resultsFilterClose).eventListener((e) => {
    e.preventDefault()

    new Helpers(body).removeClass(
        resultsFilterClass,
        noScrollClass,
    )
})

// Hide mobile filters and return to search
// when clicking apply
new Helpers(resultFilterApply).eventListener((e) => {
    e.preventDefault()

    new Helpers(body).removeClass(
        resultsFilterClass,
        noScrollClass,
    )
})

